import { Alert } from '@janeapp/burrito-design-system';
import { useAppSelector } from '~/state';
import {
  selectCanUseGeolocation,
  selectLocationIsSupportedArea,
} from '~/state/location';
import cn from 'classnames';

export const GEOLOCATION_DISABLED =
  'To continue, allow your browser to access your location or search for a location manually.';

export const LOCATION_NOT_SUPPORTED =
  "Practitioner Search isn't available in your area yet.";

export const GeolocationAlert = () => {
  const canUseGeolocation = useAppSelector(selectCanUseGeolocation);
  const isSupported = useAppSelector(selectLocationIsSupportedArea);

  if (canUseGeolocation && isSupported) return null;

  let hidden = canUseGeolocation;
  let content = GEOLOCATION_DISABLED;

  if (canUseGeolocation && !isSupported) {
    hidden = false;
    content = LOCATION_NOT_SUPPORTED;
  }

  const classes = cn('transition-opacity duration-300 ease-in-out', {
    'opacity-0': hidden,
    'opacity-100': !hidden,
  });

  return (
    <Alert
      tone="warning"
      className={classes}
      data-testid="splash-panel-alert-content"
    >
      <Alert.Content>{content}</Alert.Content>
    </Alert>
  );
};
